var app = angular.module("leonardo");

function canAccessDashboard(PermissionService, FilterService, AuthDataService) {
   return (
      FilterService.properties.length > 0 &&
      (AuthDataService.isAdmin() || PermissionService.permissionAvailable('permission_view_thoughtspot_reporting'))
    );
}

var ReportStates = function($stateProvider) {

  $stateProvider.state('administrative-reports', {
    url: '/administrative-reports',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'administrative-reports.billing',
    ncyBreadcrumb: {
      label: 'Reports'
    }
  });


  $stateProvider.state('administrative-reports.billing', {
    url: "/billing",
    cssClass: 'page-reports',
    reportTitle: 'Billing reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsBillingListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/billing.html',
        controller: 'ReportsBillingList'
      }
    },
    ncyBreadcrumb: {
      label: 'Billing Reports'
    }
  });

  $stateProvider.state('administrative-reports.action-item', {
    url: "/action-item",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/action-item.html',
        controller: 'ReportsList'
      }
    },
    ncyBreadcrumb: {
      label: 'Reports List'
    }
  });

  $stateProvider.state('administrative-reports.admin-action-item', {
    url: "/admin-action-item",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/action-item.html',
        controller: 'ReportsList'
      }
    },
    ncyBreadcrumb: {
      label: 'Reports List'
    }
  });

  $stateProvider.state('administrative-reports.mimo', {
    url: "/mimo",
    cssClass: 'page-reports',
    reportTitle: 'Move In / Move Out reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsMimoListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/mimo.html',
        controller: 'ReportsMimoList'
      }
    },
    ncyBreadcrumb: {
      label: 'Move In / Move Out List'
    }
  });

  $stateProvider.state('administrative-reports.admin-mimo', {
    url: "/admin-mimo",
    cssClass: 'page-reports',
    reportTitle: 'Move In / Move Out reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsMimoListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/mimo.html',
        controller: 'ReportsMimoList'
      }
    },
    ncyBreadcrumb: {
      label: 'Move In / Move Out List'
    }
  });

  $stateProvider.state('administrative-reports.activity', {
    url: "/activity",
    cssClass: 'page-reports',
    reportTitle: 'Activity reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsActivityListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/activity.html',
        controller: 'ReportsActivityList'
      }
    },
    ncyBreadcrumb: {
      label: 'Activity Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-activity', {
    url: "/admin-activity",
    cssClass: 'page-reports',
    reportTitle: 'Activity reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsActivityListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/activity.html',
        controller: 'ReportsActivityList'
      }
    },
    ncyBreadcrumb: {
      label: 'Activity Reports'
    }
  });

  $stateProvider.state('administrative-reports.unit', {
    url: "/unit",
    cssClass: 'page-reports',
    reportTitle: 'Unit Workflow reports',
    by_unit: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Unit Workflow Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-unit', {
    url: "/admin-unit",
    cssClass: 'page-reports',
    reportTitle: 'Unit Workflow reports',
    by_unit: true,
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Unit Workflow Reports'
    }
  });

  $stateProvider.state('administrative-reports.workflow', {
    url: "/workflow",
    cssClass: 'page-reports',
    reportTitle: 'Workflow reports',
    by_unit: false,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Workflow Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-workflow', {
    url: "/admin-workflow",
    cssClass: 'page-reports',
    reportTitle: 'Workflow reports',
    by_unit: false,
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Workflow Reports'
    }
  });

  $stateProvider.state('administrative-reports.dynamic', {
    url: "/dynamic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDynamicFormListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form.html',
        controller: 'ReportsDynamicFormList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-dynamic', {
    url: "/admin-dynamic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDynamicFormListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form.html',
        controller: 'ReportsDynamicFormList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Reports'
    }
  });

  $stateProvider.state('administrative-reports.contact', {
    url: "/contact",
    cssClass: 'page-reports',
    reportTitle: 'Contact reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsContactListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/contact.html',
        controller: 'ReportsContactList'
      }
    },
    ncyBreadcrumb: {
      label: 'Contact Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-contact', {
    url: "/admin-contact",
    cssClass: 'page-reports',
    reportTitle: 'Contact reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsContactListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/contact.html',
        controller: 'ReportsContactList'
      }
    },
    ncyBreadcrumb: {
      label: 'Contact Reports'
    }
  });

  $stateProvider.state('administrative-reports.statistic', {
    url: "/statistic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form Statistic reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsStatisticListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form-statistic.html',
        controller: 'ReportsStatisticList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Statistic Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-statistic', {
    url: "/admin-statistic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form Statistic reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsStatisticListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form-statistic.html',
        controller: 'ReportsStatisticList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Statistic Reports'
    }
  });

  $stateProvider.state('administrative-reports.template', {
    url: "/templates",
    cssClass: 'page-reports',
    reportTitle: 'Template Activity reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsTemplateListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/template.html',
        controller: 'ReportsTemplateList'
      }
    },
    ncyBreadcrumb: {
      label: 'Template Activity Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-template', {
    url: "/admin-templates",
    cssClass: 'page-reports',
    reportTitle: 'Template Activity reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsTemplateListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/template.html',
        controller: 'ReportsTemplateList'
      }
    },
    ncyBreadcrumb: {
      label: 'Template Activity Reports'
    }
  });

  $stateProvider.state('administrative-reports.property', {
    url: "/property",
    cssClass: 'page-reports',
    reportTitle: 'Property reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsPropertyListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/property.html',
        controller: 'ReportsPropertyList'
      }
    },
    ncyBreadcrumb: {
      label: 'Property Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-property', {
    url: "/admin-property",
    cssClass: 'page-reports',
    reportTitle: 'Property reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsPropertyListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/property.html',
        controller: 'ReportsPropertyList'
      }
    },
    ncyBreadcrumb: {
      label: 'Property Reports'
    }
  });

  $stateProvider.state('administrative-reports.on-demand-instruction', {
    url: "/on-demand-instructions",
    cssClass: 'page-reports',
    reportTitle: 'On Demand Instruction reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsOnDemandListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/on-demand-instruction.html',
        controller: 'ReportsOnDemandList'
      }
    },
    ncyBreadcrumb: {
      label: 'On Demand Instruction Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-on-demand-instruction', {
    url: "/admin-on-demand-instructions",
    cssClass: 'page-reports',
    reportTitle: 'On Demand Instruction reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsOnDemandListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/on-demand-instruction.html',
        controller: 'ReportsOnDemandList'
      }
    },
    ncyBreadcrumb: {
      label: 'On Demand Instruction Reports'
    }
  });

  $stateProvider.state('administrative-reports.documents', {
    url: "/documents",
    cssClass: 'page-reports',
    reportTitle: 'Documents Report',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDocumentListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/documents.html',
        controller: 'ReportsDocumentList'
      }
    },
    ncyBreadcrumb: {
      label: 'Documents Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-documents', {
    url: "/admin-documents",
    cssClass: 'page-reports',
    reportTitle: 'Documents Report',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDocumentListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/documents.html',
        controller: 'ReportsDocumentList'
      }
    },
    ncyBreadcrumb: {
      label: 'Documents Reports'
    }
  });

  $stateProvider.state('administrative-reports.work-orders', {
    url: "/work-orders",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkOrdersFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/work-orders.html',
        controller: 'ReportsWorkOrders'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Orders Reports'
    }
  });

  $stateProvider.state('administrative-reports.admin-work-orders', {
    url: "/admin-work-orders",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkOrdersFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/work-orders.html',
        controller: 'ReportsWorkOrders'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Orders Reports'
    }
  });

  
  $stateProvider.state('reports', {
    url: '/report',
    parent: 'authenticated.layout-main',
    views: {
      user: {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content@authenticated.layout-main': {
        template: '<div></div>',
        controller: [
          '$state',
          'FilterService',
          'AuthDataService',
          'PermissionService',
          function ($state, FilterService, AuthDataService, PermissionService) {
            const canAccess = canAccessDashboard(PermissionService, FilterService, AuthDataService);

            if (canAccess) {
              $state.go('reports.dashboard');
            } else {
              // Admins do not have my-reports
              if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
                $state.go('reports.quick');
              } else {
                $state.go('reports.my-reports');
              }
            }
          }
        ]
      }
    },
    ncyBreadcrumb: {
      label: 'Reports'
    }
  });

  $stateProvider.state('unsubscribe', {
    url: "/unsubscribe?token",
    controller: ['$state', 'AuthService', function($state, AuthService){
      if (AuthService.hasToken()) {
        $state.go('reports.unsubscribe', {token:$state.params.token});
      }
      else {
        $state.go('report-unsubscribe', {token:$state.params.token});
      }
    }],
    relative: true
  });

  $stateProvider.state('report-unsubscribe', {
    url: "/reports-unsubscribe?token",
    parent: 'layout-no-cols',
    cssClass: 'page-home',
    views: {
      'user': { templateUrl: 'views/templates/user/request.html' },
      'content': {
        templateUrl: 'views/templates/report/unsubscribe-public.html',
        controller: 'ReportsUnsubscribe'
      }
    },
    public: true
  });

  $stateProvider.state('reports.unsubscribe', {
    url: "/unsubscribe?token",
    title: 'Report Unsubscribe',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/unsubscribe.html',
        controller: 'ReportsUnsubscribe'
      }
    },
    ncyBreadcrumb: {
      label: 'Report Unsubscribe'
    }

  });

  $stateProvider.state('reports.approval-log', {
    url: "/approval-log?id",
    title: 'Approval Log PDF',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/approval-log.html',
        controller: 'ApprovalLog'
      }
    },
    ncyBreadcrumb: {
      label: 'Approval Log PDF'
    }
  });

  $stateProvider.state('reports.quick', {
    url: "/quick",
    title: 'System Quick Reports',
    mode: 'system',
    superuser: false,
    form: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'ReportsQuickFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/quick.html',
        controller: 'ReportsQuickList'
      }
    },
    ncyBreadcrumb: {
      label: '{{getReportBreadcrumb()}}'
    }

  });

  $stateProvider.state('reports.admin-quick', {
    url: "/admin-quick",
    title: 'Admin Quick Reports',
    mode: 'system',
    superuser: true,
    form: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'ReportsQuickFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/quick.html',
        controller: 'ReportsQuickList'
      }
    },
    ncyBreadcrumb: {
      label: 'Admin Quick Reports List'
    }

  });

  $stateProvider.state('reports.my-reports', {
    url: "/my-reports",
    title: 'My Reports',
    mode: 'owner',
    account: true,
    form: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'ReportsQuickFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/quick.html',
        controller: 'ReportsQuickList'
      }
    },
    ncyBreadcrumb: {
      label: 'My Reports List'
    }

  });

  $stateProvider.state('reports.quick.add', {
    url: "/add",
    title: 'Add Quick Report',
    action: 'create',
    form: true,
    views: {
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/form.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Add Quick Report'
    }

  });

  $stateProvider.state('reports.action-item', {
    url: "/action-item",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/action-item.html',
        controller: 'ReportsList'
      }
    },
    ncyBreadcrumb: {
      label: 'Reports List'
    }

  });

  $stateProvider.state('reports.admin-action-item', {
    url: "/admin-action-item",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/action-item.html',
        controller: 'ReportsList'
      }
    },
    ncyBreadcrumb: {
      label: 'Reports List'
    }

  });

  $stateProvider.state('reports.mimo', {
    url: "/mimo",
    cssClass: 'page-reports',
    reportTitle: 'Move In / Move Out reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsMimoListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/mimo.html',
        controller: 'ReportsMimoList'
      }
    },
    ncyBreadcrumb: {
      label: 'Move In / Move Out List'
    }

  });

  $stateProvider.state('reports.admin-mimo', {
    url: "/admin-mimo",
    cssClass: 'page-reports',
    reportTitle: 'Move In / Move Out reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsMimoListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/mimo.html',
        controller: 'ReportsMimoList'
      }
    },
    ncyBreadcrumb: {
      label: 'Move In / Move Out List'
    }

  });

  $stateProvider.state('reports.activity', {
    url: "/activity",
    cssClass: 'page-reports',
    reportTitle: 'Activity reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsActivityListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/activity.html',
        controller: 'ReportsActivityList'
      }
    },
    ncyBreadcrumb: {
      label: 'Activity Reports'
    }

  });

  $stateProvider.state('reports.admin-activity', {
    url: "/admin-activity",
    cssClass: 'page-reports',
    reportTitle: 'Activity reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsActivityListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/activity.html',
        controller: 'ReportsActivityList'
      }
    },
    ncyBreadcrumb: {
      label: 'Activity Reports'
    }

  });

  $stateProvider.state('reports.unit', {
    url: "/unit",
    cssClass: 'page-reports',
    reportTitle: 'Unit Workflow reports',
    by_unit: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Unit Workflow Reports'
    }

  });

  $stateProvider.state('reports.admin-unit', {
    url: "/admin-unit",
    cssClass: 'page-reports',
    reportTitle: 'Unit Workflow reports',
    by_unit: true,
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Unit Workflow Reports'
    }

  });

  $stateProvider.state('reports.workflow', {
    url: "/workflow",
    cssClass: 'page-reports',
    reportTitle: 'Workflow reports',
    by_unit: false,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Workflow Reports'
    }

  });

  $stateProvider.state('reports.admin-workflow', {
    url: "/admin-workflow",
    cssClass: 'page-reports',
    reportTitle: 'Workflow reports',
    by_unit: false,
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkflowListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/workflow.html',
        controller: 'ReportsWorkFlowList'
      }
    },
    ncyBreadcrumb: {
      label: 'Workflow Reports'
    }

  });

  $stateProvider.state('reports.dynamic', {
    url: "/dynamic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDynamicFormListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form.html',
        controller: 'ReportsDynamicFormList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Reports'
    }

  });

  $stateProvider.state('reports.admin-dynamic', {
    url: "/admin-dynamic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDynamicFormListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form.html',
        controller: 'ReportsDynamicFormList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Reports'
    }

  });

  $stateProvider.state('reports.contact', {
    url: "/contact",
    cssClass: 'page-reports',
    reportTitle: 'Contact reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsContactListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/contact.html',
        controller: 'ReportsContactList'
      }
    },
    ncyBreadcrumb: {
      label: 'Contact Reports'
    }

  });

  $stateProvider.state('reports.admin-contact', {
    url: "/admin-contact",
    cssClass: 'page-reports',
    reportTitle: 'Contact reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsContactListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/contact.html',
        controller: 'ReportsContactList'
      }
    },
    ncyBreadcrumb: {
      label: 'Contact Reports'
    }

  });

  $stateProvider.state('reports.statistic', {
    url: "/statistic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form Statistic reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsStatisticListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form-statistic.html',
        controller: 'ReportsStatisticList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Statistic Reports'
    }

  });

  $stateProvider.state('reports.admin-statistic', {
    url: "/admin-statistic",
    cssClass: 'page-reports',
    reportTitle: 'Dynamic Form Statistic reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsStatisticListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/dynamic-form-statistic.html',
        controller: 'ReportsStatisticList'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Statistic Reports'
    }

  });

  $stateProvider.state('reports.template', {
    url: "/templates",
    cssClass: 'page-reports',
    reportTitle: 'Template Activity reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsTemplateListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/template.html',
        controller: 'ReportsTemplateList'
      }
    },
    ncyBreadcrumb: {
      label: 'Template Activity Reports'
    }

  });

  $stateProvider.state('reports.admin-template', {
    url: "/admin-templates",
    cssClass: 'page-reports',
    reportTitle: 'Template Activity reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsTemplateListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/template.html',
        controller: 'ReportsTemplateList'
      }
    },
    ncyBreadcrumb: {
      label: 'Template Activity Reports'
    }

  });

  $stateProvider.state('reports.property', {
    url: "/property",
    cssClass: 'page-reports',
    reportTitle: 'Property reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsPropertyListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/property.html',
        controller: 'ReportsPropertyList'
      }
    },
    ncyBreadcrumb: {
      label: 'Property Reports'
    }

  });

  $stateProvider.state('reports.admin-property', {
    url: "/admin-property",
    cssClass: 'page-reports',
    reportTitle: 'Property reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsPropertyListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/property.html',
        controller: 'ReportsPropertyList'
      }
    },
    ncyBreadcrumb: {
      label: 'Property Reports'
    }

  });

  $stateProvider.state('reports.on-demand-instruction', {
    url: "/on-demand-instructions",
    cssClass: 'page-reports',
    reportTitle: 'On Demand Instruction reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsOnDemandListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/on-demand-instruction.html',
        controller: 'ReportsOnDemandList'
      }
    },
    ncyBreadcrumb: {
      label: 'On Demand Instruction Reports'
    }

  });

  $stateProvider.state('reports.admin-on-demand-instruction', {
    url: "/admin-on-demand-instructions",
    cssClass: 'page-reports',
    reportTitle: 'On Demand Instruction reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsOnDemandListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/on-demand-instruction.html',
        controller: 'ReportsOnDemandList'
      }
    },
    ncyBreadcrumb: {
      label: 'On Demand Instruction Reports'
    }

  });

  $stateProvider.state('reports.documents', {
    url: "/documents",
    cssClass: 'page-reports',
    reportTitle: 'Documents reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDocumentListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/documents.html',
        controller: 'ReportsDocumentList'
      }
    },
    ncyBreadcrumb: {
      label: 'Documents Reports'
    }

  });

  $stateProvider.state('reports.missing-documents', {
    url: "/missing-documents",
    cssClass: 'page-reports',
    reportTitle: 'Missing Documents reports',
    missing_documents: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDocumentListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/missing-documents.html',
        controller: 'ReportsDocumentList'
      }
    },
    ncyBreadcrumb: {
      label: 'Missing Documents Reports'
    }

  });

  $stateProvider.state('reports.admin-documents', {
    url: "/admin-documents",
    cssClass: 'page-reports',
    reportTitle: 'Documents reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDocumentListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/documents.html',
        controller: 'ReportsDocumentList'
      }
    },
    ncyBreadcrumb: {
      label: 'Documents Reports'
    }

  });

  $stateProvider.state('reports.admin-missing-documents', {
    url: "/admin-missing-documents",
    cssClass: 'page-reports',
    reportTitle: 'Missing Documents reports',
    superuser: true,
    missing_documents: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsDocumentListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/missing-documents.html',
        controller: 'ReportsDocumentList'
      }
    },
    ncyBreadcrumb: {
      label: 'Missing Documents Reports'
    }

  });

  $stateProvider.state('reports.document', {
    url: "/document",
    cssClass: 'page-reports',
    title: 'Report Warehouse',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentFiltersExpired'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/report.html',
        controller: 'DocumentListReport'
      }
    },
    ncyBreadcrumb: {
      label: 'Report Warehouse'
    }
  });

  $stateProvider.state('reports.admin-property-amenities', {
    url: "/admin-property-amenities",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    superuser: true,
    amenities: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsPropertyAmenitiesListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/property-amenities.html',
        controller: 'ReportsPropertyAmenitiesList'
      }
    },
    ncyBreadcrumb: {
      label: 'Reports Attributes List'
    }

  });

  $stateProvider.state('reports.property-amenities', {
    url: "/property-amenities",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    amenities: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsPropertyAmenitiesListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/property-amenities.html',
        controller: 'ReportsPropertyAmenitiesList'
      }
    },
    ncyBreadcrumb: {
      label: 'Reports Attributes List'
    }

  });

  $stateProvider.state('reports.work-orders', {
    url: "/work-orders",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkOrdersFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/work-orders.html',
        controller: 'ReportsWorkOrders'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Orders Reports'
    }
  });

  $stateProvider.state('reports.admin-work-orders', {
    url: "/admin-work-orders",
    cssClass: 'page-reports',
    reportTitle: 'Action Item reports',
    superuser: true,
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkOrdersFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/work-orders.html',
        controller: 'ReportsWorkOrders'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Orders Reports'
    }
  });

  $stateProvider.state('reports.dashboard', {
    url: '/dashboard',
    title: 'Reports Dashboard',
    resolve: {
      dashboardAccess: [
        '$q',
        'FilterService',
        'AuthDataService',
        'PermissionService',
        'NavigationService',
        function ($q, FilterService, AuthDataService, PermissionService, NavigationService) {
          const canAccess = canAccessDashboard(PermissionService, FilterService, AuthDataService);

          if (!canAccess) {
            NavigationService.goToHome();
            return $q.reject('NO_DASHBOARD_ACCESS');
          }

          return $q.resolve(true);
        }
      ]
    },
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/reporting-dashboard.html',
        controller: 'ReportingDashboardCtrl'
      }
    },
    ncyBreadcrumb: {
      label: 'Dashboard'
    }
  });

  $stateProvider.state('reports.work-order-activity', {
    url: "/work-order-activity",
    params: {
      reportType: '17',
      reportTitle: 'Work Order Activity Reports'
    },
    cssClass: 'page-reports',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/reports.html',
        controller: 'ReportsActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/report/filters.html',
        controller: 'ReportsWorkOrdersFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/report/work-order-activity.html',
        controller: 'ReportsWorkOrders'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Orders Activity'
    }
  });

};

app.config(['$stateProvider', ReportStates]);
